/* eslint-disable react/prefer-stateless-function no-unused-expressions no-useless-escape */
import React from 'react';
import {
  Grid,
  Typography,
  withStyles,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Hidden,
  Fade,
  AppBar,
  IconButton,
  Toolbar
} from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import CloudDownload from '@material-ui/icons/CloudDownload';

import ReactGA from 'react-ga';
import jsonp from 'jsonp';
import SectionHeader from '../../components/SectionHeader';
import Asset from '../../components/Asset';
import Privacy from './Privacy';

const styles = theme => ({
  order: {
    backgroundColor: theme.palette.grey[100]
  },
  img: {
    paddingRight: '100px'
  },
  sendingMsg: {
    color: theme.palette.secondary.dark
  },
  errorMsg: {
    color: theme.palette.error.dark
  },
  successMsg: {
    color: theme.palette.primary.dark
  },
  duplicateMsg: {
    color: theme.palette.error.light
  },
  terms: {
    fontSize: 14,
    fontWeight: 400
  },
  headline: {
    color: theme.palette.secondary.main,
    fontSize: 30,
    fontWeight: 700
  },
  cta: {
    fontSize: 26,
    fontWeight: 700,
    color: theme.palette.primary.main
  },
  soon: {
    fontSize: 46,
    fontWeight: 700,
    color: theme.palette.secondary.main,
    marginTop: '50px'
  },
  downloadColor: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 700,
    color: '#ffffff',
    textDecoration: 'none',
    fontFamily: 'Titillium Web, Roboto, sans-serif',
    background: theme.palette.primary.main,
    padding: 10,
    borderRadius: 4,
    marginBottom: '20px',
    verticalAlign: 'bottom',
    display: 'inline-block',
    boxShadow:
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  downloadBw: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 700,
    textDecoration: 'none',
    fontFamily: 'Titillium Web, Roboto, sans-serif',
    backgroundColor: '#444444',
    color: '#eeeeee',
    borderRadius: 4,
    verticalAlign: 'bottom',
    padding: 10,
    display: 'inline-block',
    boxShadow:
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    '&:hover': {
      backgroundColor: '#666666'
    }
  }
});

const mcUrl =
  'https://u2i.us20.list-manage.com/subscribe/post-json?u=7c26c6bae0bb00ee4e2834437&amp;id=a0bdd567f4';

const messages = {
  sending: 'Sending...',
  success: 'Thank you for subscribing!',
  error: 'An unexpected internal error has occurred.',
  empty: 'You must write an e-mail.',
  duplicate: 'Too many subscribe attempts for this email address',
  button: 'Subscribe!'
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const Order = class extends React.Component {
  state = {
    email: '',
    status: '',
    terms: false,
    open: false
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSubmit(evt) {
    evt.preventDefault();
    const { email } = this.state;
    const path = `${mcUrl}&EMAIL=${encodeURIComponent(email)}`;
    const regex = /^([\w_\.\-\+])+\@([\w\-]+\.)+([\w]{2,10})+$/;
    if (!regex.test(email) && !email) {
      this.setState({ status: 'empty' });
    } else {
      this.sendData(path);
    }
  }

  sendData(url) {
    this.setState({ status: 'sending' });
    jsonp(url, { param: 'c' }, (err, data) => {
      if (data.msg.includes('already subscribed')) {
        this.setState({ status: 'duplicate' });
      } else if (err) {
        this.setState({ status: 'error' });
      } else if (data.result !== 'success') {
        this.setState({ status: 'error' });
      } else {
        this.setState({ status: 'success' });
      }
    });
  }

  render() {
    const { classes } = this.props;
    const { email, status, terms, open } = this.state;
    const visibility = email ? 'block' : 'none';
    return (
      <section className={classes.order}>
        <Dialog
          fullScreen
          open={open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Privacy />
        </Dialog>
        <div className="wrapper">
          <Grid
            container
            direction="column"
            justify="center"
            style={{ minHeight: '60vh' }}
          >
            <Grid item>
              <SectionHeader
                color="primary"
                text="Download"
                subcolor="secondary"
                subtitle='aka "I want a copy" aka "Shut up and take my money"'
                img={10}
                imgHeight="40"
              />
            </Grid>
            <Grid item>
              <Grid container spacing={24} alignItems="center">
                <Grid item xs>
                  <Grid
                    container
                    alignItems="center"
                    style={{ marginBottom: '40px' }}
                  >
                    <Hidden mdUp>
                      <Grid item xs={12} md={4}>
                        <div style={{ textAlign: 'center' }}>
                          <Fade in timeout={1000}>
                            <img
                              src="/images/assets/asset-52.png"
                              alt="Order section"
                            />
                          </Fade>
                        </div>
                      </Grid>
                    </Hidden>

                    <Grid item md={2} />
                    <Grid item xs md={6}>
                      <Typography paragraph variant="body1">
                        OK, so we did something right and something very wrong.
                        We managed to get you hyped but for some reason (that is
                        surely our fault <Asset img={35} />) you don't yet have
                        a copy of your own. Fear not my friend. We’ve got you
                        covered!
                        {/* Just give us your email (we */}
                        {/* promise not to spam you too much) and we will let you know */}
                        {/* when and how you can buy it. <Asset img={37} /> */}
                      </Typography>
                    </Grid>
                    <Hidden smDown>
                      <Grid item xs={12} md={4}>
                        <div style={{ textAlign: 'center' }}>
                          <Fade in timeout={1000}>
                            <img
                              src="/images/assets/asset-52.png"
                              alt="Order section"
                            />
                          </Fade>
                        </div>
                      </Grid>
                    </Hidden>
                  </Grid>
                  <Grid container spacing={24} alignItems="flex-start">
                    <Grid item xs={12} md={6} style={{ marginBottom: '80px' }}>
                      <Typography
                        variant="body1"
                        align="center"
                        paragraph
                        className={classes.headline}
                      >
                        THE BEST THINGS IN LIFE ARE FREE
                      </Typography>
                      <Typography variant="body1" paragraph align="center">
                        SoftWar is available for free under a Creative Commons
                        license. Download the PDF with the full deck.
                      </Typography>
                      <Typography
                        variant="h5"
                        paragraph
                        align="center"
                        className={classes.cta}
                      >
                        I want my free copy!
                      </Typography>
                      {/* <Typography
                        variant="h4"
                        paragraph
                        align="center"
                        className={classes.soon}
                      >
                        Download NOW!
                      </Typography> */}
                      <Grid container style={{ marginTop: '50px' }}>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{
                            textAlign: 'center',
                            verticalAlign: 'bototm'
                          }}
                        >
                          <a
                            href="https://drive.google.com/open?id=1yvXo3L9JONDt8bGb_tN-XuBAyfxIsnhO"
                            target="_blank"
                            rel="noopener noreferrer"
                            download="Softwar_color"
                            className={classes.downloadColor}
                            onClick={() => {
                              ReactGA.ga(
                                'send',
                                'event',
                                'download',
                                'button',
                                'color'
                              );
                            }}
                          >
                            <CloudDownload
                              style={{
                                marginRight: '10px',
                                verticalAlign: 'bottom'
                              }}
                            />{' '}
                            Print in color
                          </a>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{
                            textAlign: 'center'
                          }}
                        >
                          <a
                            href="https://drive.google.com/open?id=1pMSKAv8TWvOGijMjZWqBW0V9hyWcAenj"
                            download="Softwar_color"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.downloadBw}
                            onClick={() => {
                              ReactGA.ga(
                                'send',
                                'event',
                                'download',
                                'button',
                                'bw'
                              );
                            }}
                          >
                            <CloudDownload
                              style={{
                                marginRight: '10px',
                                verticalAlign: 'bottom'
                              }}
                            />{' '}
                            Print in black & white
                          </a>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography
                        variant="body1"
                        align="center"
                        className={classes.headline}
                        paragraph
                      >
                        TOO LAZY, DIDN'T PRINT TL;DP
                      </Typography>
                      <Typography variant="body1" paragraph align="center">
                        Do you want to have your own copy but at the same time
                        you don’t feel like doing any DIY projects? We might be
                        able to help you! Just give us your email (we promise
                        not to spam you too much). We will let you know in the
                        upcoming months whether there’s a possibility to buy it.{' '}
                        <Asset img={37} />
                      </Typography>
                      <Typography
                        variant="h5"
                        paragraph
                        align="center"
                        className={classes.cta}
                      >
                        Let me know if I can buy it!
                      </Typography>

                      <form
                        onSubmit={this.handleSubmit.bind(this)}
                        className="mailchimp"
                      >
                        <Grid container spacing={24} alignItems="center">
                          <Hidden smDown>
                            <Grid item xs sm={2} />
                          </Hidden>
                          <Grid item xs={8} sm={6}>
                            <TextField
                              id="email"
                              label="Email"
                              value={email}
                              onChange={this.handleChange('email')}
                              margin="none"
                              name="email"
                              type="email"
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={4} sm={4}>
                            <Button
                              color="primary"
                              variant="contained"
                              disabled={
                                status === 'sending' ||
                                status === 'success' ||
                                !terms
                              }
                              type="submit"
                              onClick={() => {
                                ReactGA.ga(
                                  'send',
                                  'event',
                                  'order',
                                  'button',
                                  'subscribe'
                                );
                              }}
                            >
                              Subscribe
                            </Button>
                          </Grid>
                          <Grid item xs={12} style={{ display: visibility }}>
                            <FormControlLabel
                              className={classes.terms}
                              control={
                                <Checkbox
                                  checked={terms}
                                  onChange={this.handleChange('terms')}
                                  value="terms"
                                  color="primary"
                                />
                              }
                              label={
                                <span>
                                  I hereby give my voluntary consent to the
                                  processing of my personal data (including full
                                  name, email and postal address) by the
                                  controller of personal data – the company
                                  Union Square Internet Development Polska
                                  Spółka z o.o. with its registered office in
                                  Kraków, at ul. Przemysłowa 12A (30-701
                                  Kraków), entered into the Register of
                                  Entrepreneurs of the National Court Register
                                  kept by the District Court for Kraków -
                                  Śródmieście in Kraków, XI Commercial Division
                                  of the National Court Register, under the KRS
                                  entry number 0000241012, NIP no.
                                  781-176-99-33, REGON no. 300095971 ["Union
                                  Square Internet Development Polska"], for the
                                  purposes of providing product marketing
                                  information.
                                  <br />
                                  <br />I hereby declare that I have read{' '}
                                  <a
                                    href="https://drive.google.com/open?id=1oXX52nB-npAbA7ywlwKnDLgT2ltO-117i6AbD5lB0E8"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    the contents of the information clause
                                  </a>
                                  , including the information about the purpose
                                  and means of personal data processing, and the
                                  right to access the contents of my data, and
                                  the right to their correction and requesting
                                  their deletion. <br />
                                  <br />
                                  The consent given by me may be withdrawn at
                                  any time, however the withdrawal of the
                                  consent will not affect the lawfulness of the
                                  processing, which was made on the basis of the
                                  consent prior to its withdrawal.
                                  <br />
                                </span>
                              }
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <div
                              className="msg-alert"
                              style={{ height: '48px' }}
                            >
                              {status === 'sending' && (
                                <Typography
                                  variant="body2"
                                  className={classes.sendingMsg}
                                >
                                  {messages.sending}
                                </Typography>
                              )}
                              {status === 'success' && (
                                <Typography
                                  variant="body2"
                                  className={classes.successMsg}
                                >
                                  {messages.success}
                                </Typography>
                              )}
                              {status === 'duplicate' && (
                                <Typography
                                  variant="body2"
                                  className={classes.duplicateMsg}
                                >
                                  {messages.duplicate}
                                </Typography>
                              )}
                              {status === 'empty' && (
                                <Typography
                                  variant="body2"
                                  className={classes.errorMsg}
                                >
                                  {messages.empty}
                                </Typography>
                              )}
                              {status === 'error' && (
                                <Typography
                                  variant="body2"
                                  className={classes.errorMsg}
                                >
                                  {messages.error}
                                </Typography>
                              )}
                            </div>
                          </Grid>
                        </Grid>
                      </form>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </section>
    );
  }
};

export default withStyles(styles)(Order);
